import { UserListPage } from "@/features/access/pages/user/UserListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/access/user/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_users.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: UserListPage,
});
